module.exports = __webpack_public_path__ + "img/stock7.0f7fe7ea.png";